import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

// Below this width the dashboard nav is a drawer instead of a sidebar column
// (the column itself is Tailwind `lg`, 1024 px, in Dashboard_BFC).
export const NAV_DRAWER_QUERY = "(max-width:1023.95px)";

// Touch-first devices. Use it for behaviour and hit areas, never for layout.
export const TOUCH_QUERY = "(hover: none) and (pointer: coarse)";

// noSsr: read the media queries on the first render, so a phone never paints
// the desktop layout first.
export const useViewport = () => {
  const theme = useTheme();
  const isPhone = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
  // Below MUI md (900 px): pages switch to their stacked tablet/phone layout.
  const isCompact = useMediaQuery(theme.breakpoints.down("md"), {
    noSsr: true,
  });
  // MUI lg (1200 px) and up: the desktop layout.
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"), { noSsr: true });
  const navIsDrawer = useMediaQuery(NAV_DRAWER_QUERY, { noSsr: true });
  const isTouch = useMediaQuery(TOUCH_QUERY, { noSsr: true });
  return { isPhone, isCompact, isDesktop, navIsDrawer, isTouch };
};
